
  import { defineComponent, ref, computed } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';
  import CustomDatePicker from '@/components/search/CustomDatePicker.vue';

  interface ServiceData {
    title: string;
    type: string;
    count: number;
    countChange: 'increase' | 'decrease' | 'noChange';
    countPercentage: number;
  }

  export default defineComponent({
    name: 'other-services-widget-min',
    props: {
      widgetClasses: { type: String, default: 'card-xxl-stretch mb-xl-8' },
    },
    components: {
      CustomDatePicker,
    },
    async setup() {
      const { t, te } = useI18n();
      const loading = ref(true);
      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };
      const selectedPeriod = ref('last-7-days');
      const servicesData = ref<ServiceData[]>([]);
      const store = useStore();
      const customDateFrom = ref('');
      const customDateTo = ref('');
      const showDatePicker = ref(false);

      // initial load
      await store.dispatch(Actions.GET_OTHERS_SUMMERY_DASHBOARD, {
        dateRange: selectedPeriod.value,
      });
      const data = computed(() => store.getters.othersSummaryDashboard);
      servicesData.value = data.value?.data || [];
      loading.value = false;

      const showCustomDatePicker = () => {
        showDatePicker.value = true;
        selectedPeriod.value = 'custom';
      };

      const applyCustomDates = async () => {
        if (!customDateFrom.value || !customDateTo.value) {
          alert('Please select both dates');
          return;
        }
        showDatePicker.value = false;
        await selectPeriod('custom');
      };
      const selectPeriod = async (period: string) => {
        selectedPeriod.value = period;
        loading.value = true;
        const obj = {
          dateRange: period,
          showTrend: false,
          dateFrom: '',
          dateTo: '',
        };

        if (period === 'custom' && customDateFrom.value && customDateTo.value) {
          obj.dateFrom = customDateFrom.value;
          obj.dateTo = customDateTo.value;
        }
        await store.dispatch(Actions.GET_OTHERS_SUMMERY_DASHBOARD, obj);
        servicesData.value = store.getters.othersSummaryDashboard?.data || [];
        loading.value = false;
      };

      const getIconClass = (type: string): string => {
        const map: Record<string, string> = {
          'loan-applications': 'icon-orange',
          'mortgage-application': 'icon-orange',
          'official-appraisals': 'icon-orange',
          // 'my-budget': 'icon-orange',
          'auction-assistance': 'icon-orange',
        };
        return map[type] || 'icon-orange';
      };

      const getIconPath = (type: string): string => {
        const iconPaths: Record<string, string> = {
          'loan-applications': '/media/icons/dash/loan.png',
          'official-appraisals': '/media/icons/dash/appraisal.png',
          // 'my-budget': '/media/icons/dash/budget.png',
          'auction-assistance': '/media/icons/dash/auction.png',
          'mortgage-application': '/media/icons/dash/mortgage.png',
        };
        return iconPaths[type] || '/media/icons/dash/default.png';
      };

      const getChangeSymbol = (t: ServiceData['countChange']) =>
        t === 'increase' ? '↑' : t === 'decrease' ? '↓' : '↔';

      const formatCount = (n: number) => n.toLocaleString();

      return {
        loading,
        selectedPeriod,
        servicesData,
        selectPeriod,
        getIconClass,
        getIconPath,
        getChangeSymbol,
        formatCount,
        translate,
        showDatePicker,
        customDateFrom,
        customDateTo,
        showCustomDatePicker,
        applyCustomDates,
      };
    },
  });
